module.exports = __webpack_public_path__ + "static/media/hotel-hero-1.c7dc4fb0.jpg";